module.exports = __webpack_public_path__ + "static/media/carp_mobile_splash.8069fd90.gif";